module.exports = __webpack_public_path__ + "static/media/scroll4_phone3.8f9ea0c7.png";